module.exports = __webpack_public_path__ + "static/media/praca-na-zadanie-on.a287c1c9.svg";